import { AvailableLanguages } from '@repo/toolkit/language-types'
import { Column } from '@repo/ui/data-table'
import { TFunction } from 'i18next'

import { CoachCompany } from '../../../lib/types/models/ol/coach-company/coach-company'
import { CoachCompanyInput } from '../../../lib/types/models/ol/coach-company/coach-company-input'
import { formatPhoneNumber } from '../../../utils/functions/format-phone-number'

export const mapCoachCompanyToInput = (activity: CoachCompany): CoachCompanyInput => ({
  name: activity.name,
  address1: activity.address1,
  address2: activity.address2,
  city: activity.city,
  zipCode: activity.zipCode,
  country: activity.country,
  phoneNumber: activity.phoneNumber,
  emergencyNumber: activity.emergencyNumber,
  comments: activity.comments
})

export const coachCompaniesColumns = (
  t: TFunction<AvailableLanguages, undefined>
): Column<CoachCompany>[] => [
  {
    accessorKey: 'name',
    header: t('coach.company.table.name'),
    enableSorting: true
  },
  {
    accessorKey: 'phoneNumber',
    columnHeaderClassName: 'w-1/2',
    header: t('coach.company.table.phoneNumber'),
    cell: ({ row }) => formatPhoneNumber(row.original.phoneNumber)
  },
  {
    accessorKey: 'comments',
    header: t('coach.company.table.comments'),
    enableSorting: true,
    cell: ({ row }) => row.original.comments || '-'
  }
]

export const getCoachCompaniesColumns = (
  t: TFunction<AvailableLanguages, undefined>
): Column<CoachCompany>[] => {
  return coachCompaniesColumns(t)
}
